


















import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {}
})

export default class InviteBtn extends Vue {
    private urlRoom = window.location.href;
    private success: boolean = false;

    private successCopy():void
    {
        this.success = true;

        setTimeout(() => {
            this.success = false;
        }, 1000);
    }
}
